module.exports = {
	extends: [
		'/',
		'templates',
		'mediaManagement',
		'media'
	],

	config: {
		listComponentClass: 'templates_mediaManagement_image_imageList',
		listElementComponentClass: 'base_form_media_image_image',
		nrOfElementsComponentClass: 'templates_mediaManagement_image_nrOfElements',
		listNewElementContainerClass: '.newImages',
		getCategorizedMediaActionName: 'getCategorizedMedia'
	},

	methods: {
		dataDealer: function () {
			this.model.imageConfig = this.getResourceRegisterContent('imageConfig') || {};
			this.model.managementConfig = this.model.imageConfig.managementConfig || {};
		}
	}
};